import React from "react";
import { RadioGroup, FormControlLabel, Radio, Typography, Box } from "@mui/material";
import { PrimaryTooltip } from "./StyledComponent";

// Single-choice radio row, in the form styling the rest of the platform uses (see the
// warranty question the Record Replacement form asked before it went multi-pack).
//
// Takes the same option shape a segmented control would - { code, label, disabled,
// disabledReason } - so a field can move between the two presentations without its call
// site changing, and so an option can be shown-but-unselectable with the reason on hover
// (Condition "New" is only valid for grade Type 1).
export default function RadioOptionGroup({
    options = [],
    value = "",
    onChange = () => {},
    error = false,
    disabled = false,
    row = true,
    testIdPrefix,
    ariaLabel,
}) {
    return (
        <Box>
            <RadioGroup
                row={row}
                aria-label={ariaLabel}
                value={value || ""}
                onChange={(event) => onChange(event.target.value)}
                sx={{ gap: row ? "8px" : 0 }}
            >
                {options.map((option) => {
                    const isDisabled = disabled || !!option.disabled;
                    const control = (
                        <FormControlLabel
                            key={option.code}
                            value={option.code}
                            disabled={isDisabled}
                            control={
                                <Radio
                                    size="small"
                                    data-testid={
                                        testIdPrefix ? `${testIdPrefix}-${option.code}` : undefined
                                    }
                                    sx={{
                                        color: error ? "#F04438" : "#98A2B3",
                                        "&.Mui-checked": { color: "#6D72F6" },
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        color: isDisabled ? "#BDBDBD" : "#2E2E2E",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {option.label}
                                </Typography>
                            }
                            sx={{ marginRight: "12px" }}
                        />
                    );

                    // A disabled option is the only one that needs explaining; a plain
                    // dimmed radio has no way to say why it cannot be picked. The span is
                    // required because MUI disables pointer events on the control itself,
                    // which would swallow the tooltip's hover.
                    return isDisabled && option.disabledReason ? (
                        <PrimaryTooltip
                            key={option.code}
                            title={option.disabledReason}
                            placement="top"
                        >
                            <span style={{ display: "inline-flex" }}>{control}</span>
                        </PrimaryTooltip>
                    ) : (
                        control
                    );
                })}
            </RadioGroup>
        </Box>
    );
}
